import React from "react";
import { Box, Typography } from "@mui/material";

const AzureVirtualMachineCreation = ({
  activeTabName,
  formConfig,
  formData,
  renderField,
  shouldHideField,
  renderTagsSection,
}) => {
  const fieldGroups = new Map();

  formConfig
    .filter(
      (field) =>
        field.tabName === activeTabName &&
        field.fieldType !== "collection" &&
        !shouldHideField(field, formData)
    )
    .forEach((field) => {
      const groupName = field.subTab || "";
      if (!fieldGroups.has(groupName)) fieldGroups.set(groupName, []);
      fieldGroups.get(groupName).push(field);
    });

  return (
    <Box sx={{ width: "100%", color: "text.primary" }}>
      {Array.from(fieldGroups, ([groupName, fields]) => (
        <Box key={groupName || "default"} sx={{ width: "100%" }}>
          {groupName && groupName.toLowerCase().trim() !== "general" && (
            <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold", mb: 1, mt: 2 }}>
              {groupName}
            </Typography>
          )}
          <Box sx={{ display: "flex", width: "100%", flexWrap: "wrap", gap: "12px" }}>
            {fields.map((field) => {
              const renderedField = renderField(field);
              if (!renderedField) return null;

              const isFullWidth =
                field.fieldName === "masterUsername" || field.fieldType === "checkbox";

              return (
                <Box
                  key={field.fieldId ?? field.fieldName}
                  sx={{
                    flex: isFullWidth ? "1 1 100%" : "1 1 calc(50% - 16px)",
                    minWidth: "300px",
                    mr: 1,
                    mb: 1,
                  }}
                >
                  {renderedField}
                </Box>
              );
            })}
          </Box>
        </Box>
      ))}
      {activeTabName === "Tag" && renderTagsSection()}
    </Box>
  );
};

export default AzureVirtualMachineCreation;
